import React, { useContext, useEffect, useRef, useState } from "react";

import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useForm } from "../../../../Base/Hooks/useForm";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { NumericFormat } from "react-number-format";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";

import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import Loader from "../../../../Base/Components/Loader/Loader";

import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getDateTimeStringSQL } from "../../../../Base/Services/Moment/Luxon";
import { setDateTimeSQLH } from "../../../../Base/Services/FechasService";
import { RedondearNumero } from "../../../../Base/Utils/Funciones/Funciones";
import { getCurrencyIPS } from '../../../../APIPR/Global/Currency/CurrencyRequest'
import { getEstadoPagoProveedores } from '../../../../APIPR/Global/Estados/StatusRequest'
import { 
  getPagoProveedorEnc,
  getPagoProveedorDetalles,
  postPagoProveedor,
} from '../../../../APIPR/CuentasPorPagar/PagosProveedores/PagosProveedoresRequest'
import { getCompanyRevisados } from '../../../../APIPR/Company/CompanyRequest';
import OverlayFacturasPendientesPorPagar from "./OverlayFacturasPendientesPorPagar";
import {
  numeroALetras,
  numeroALetrasEN,
} from "../../../../Base/Services/funciones";

const ModalPagosProveedores = ({ dialogPago, hideDialog, IdPago }) => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [listadoDetalles, setListadoDetalles] = useState([]);
  const [selected, setSelected] = useState([]);
  const [dialogReporte, setDialogReporte] = useState(false);
  const [openOverlay, setOpenOverlay] = useState(false);
  const [detallesNuevos, setDetallesNuevos] = useState([]);
  const [habilitar, setHabilitar] = useState(true);

  const valoresIniciales = {
    IdPago: -100,
    NumeroPago: "PP",
    IdEstado: 2117,
    IdTipoPago: 1,
    IdProveedor: null,
    IdMoneda: 1,
    TasaCambio: 0,
    MontoL: 0,
    MontoD: 0,
    FechaPago: new Date(),
    Memo: "",
    CantidadLetrasL: "",
    CantidadLetrasD: "",
    IdCuentaPrincipal: null,
  };

  const { values, setValues, handleInputChange, resetForm } = useForm({
    ...valoresIniciales,
  });
  const { userAuth } = useContext(AuthContext);

  const MontoLetras = (tempoValues) => {
    const letras = numeroALetras(tempoValues.MontoL, {
      plural: "Lempiras",
      singular: "Lempira",
      centPlural: "CENTAVOS",
      centSingular: "CENTAVO",
    });
    const letrasES = numeroALetrasEN(tempoValues.MontoD, {
      plural: "DOLLARS",
      singular: "Dollar",
      centPlural: "CENTS",
      centSingular: "CENT",
    });

    const letraMin = letras.toLowerCase();
    const letraMinEN = letrasES.toLowerCase();

    tempoValues.CantidadLetrasL = letraMin[0].toUpperCase() + letraMin.slice(1);
    tempoValues.CantidadLetrasD =
      letraMinEN[0].toUpperCase() + letraMinEN.slice(1);
    setValues(tempoValues);
  };

  const obtenerInformacion = async (TempoIdPago) => {
    setLoading(true);

    if (TempoIdPago > 0) {
      const tempoEnc = await getPagoProveedorEnc(TempoIdPago);

      if (tempoEnc?.length > 0) {
        setValues({
          ...tempoEnc[0],
          FechaPago: new Date(tempoEnc[0]?.Fecha),
        });

        if (tempoEnc[0].Aplicado === 1 || tempoEnc[0].Aplicado === true) {
          setHabilitar(false);
        } else {
          setHabilitar(true);
        }
        await obtenerDetallesPago(tempoEnc[0]?.IdPago);
      }
    } else {
      setValues({
        ...valoresIniciales,
        FechaPago: new Date(),
      });

      setListadoDetalles([]);
    }

    setLoading(false);
  };

  const obtenerDropdowns = async () => {
    const tempoEstados = await getEstadoPagoProveedores();
    setEstados(tempoEstados);
    const tempoMonedas = await getCurrencyIPS();
    setMonedas(tempoMonedas);
    const tempoProveedores = await getCompanyRevisados();
    setProveedores(tempoProveedores);
  };

  const obtenerDetallesPago = async (IdPago) => {
    setLoading(true);
    const tempoDetalles = await getPagoProveedorDetalles(IdPago);
    setListadoDetalles(tempoDetalles);
    setLoading(false);
  };
  const onHide = () => {
    hideDialog(false);
    setSelected(null);
  };
  const GuardarPago = async () => {
    if (!values.IdProveedor)
      return toastShow(toast, "error", "Seleccione un proveedor");
    if (!values.FechaPago)
      return toastShow(toast, "error", "Seleccione una fecha de pago");
    if (!values.Memo) return toastShow(toast, "error", "Ingrese un memo");
    if (!values.TasaCambio || values.TasaCambio <= 0)
      return toastShow(toast, "error", "Ingrese una tasa de cambio válida");

    confirmDialog({
      message: "¿Está seguro que desea guardar la información?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        setLoading(true);
        const datosEnviar = {
          Encabezado: {
            ...values,
            IdUserEdit: userAuth.idUser,
            IdUserCreo: userAuth.idUser,
            FechaPago: setDateTimeSQLH(values.FechaPago),
          },
          Detalles: listadoDetalles,
        };
        const result = await postPagoProveedor(datosEnviar);
        if (result?.[0]?.ERROR === 0) {
          toastShow(toast, "success", result[0]?.MENSAJE);
          obtenerInformacion(result[0]?.IdPago);
          onHide();
        } else {
          toastShow(toast, "error", result?.[0]?.MENSAJE);
        }
        setLoading(false);
      },
      reject: () => {},
    });
  };

const AsignarMontos = (tempoValues, detalles) => {
  let tempoMontoL = Number(detalles.reduce((t, v) => t + v.MontoPagadoL, 0).toFixed(4));
  let tempoMontoD = Number(detalles.reduce((t, v) => t + v.MontoPagadoD, 0).toFixed(4));

  tempoValues.MontoL = RedondearNumero(tempoMontoL);
  tempoValues.MontoD = RedondearNumero(tempoMontoD);
  tempoValues.Monto = RedondearNumero(
    tempoValues.IdMoneda === 1
      ? tempoValues.MontoD > 0 ? tempoValues.MontoD : tempoValues.MontoL
      : tempoValues.MontoL,
  );

  MontoLetras(tempoValues);
};

  const NuevaFila = (informacionFacturas, temValue = values) => {
    if (temValue.TasaCambio > 0) {
      let IdExiste = listadoDetalles.some((l) =>
        informacionFacturas.some(
          (i) =>
            i.IdIngreso === l.IdIngreso &&
            i.IdReferencia === l.IdTipoReferencia,
        ),
      );
      if (!IdExiste) {
        let dataNueva = informacionFacturas.map((i, index) => {
          let IdAleatorio = (listadoDetalles?.length + index + 1) * -1;
          return {
            IdDetallePago: IdAleatorio,
            IdPago: temValue?.IdPago ? temValue?.IdPago : -100,
            IdIngreso: i.IdIngreso,
            NumeroIngreso: i.NumeroIngreso,
            IdIngresoReferencia: i.IdIngresoReferencia,
            FechaIngreso: i.FechaIngreso,
            IdTipoReferencia: i.IdReferencia,
            IdTipoDocumento: i.IdTipoDocumento,
            Factura: i.Factura,
            IdPO: i.IdPO,
            PO: i.PO,
            IdEstadoDet: 2070,
            IdUserCreo: userAuth.idUser,
            FechaCreado: getDateTimeStringSQL(new Date()),
            IdMoneda: temValue.IdMoneda,
            TasaCambio: temValue.TasaCambio,
            MontoFacturaL: i.IdTipoDocumento === 1 ? i.MontoL : i.DebitoL,
            MontoFacturaD: i.IdTipoDocumento === 1 ? i.MontoD : i.DebitoD,
            MontoPagadoL: i.BalanceDisponibleL,
            MontoPagadoD: i.BalanceDisponibleD,
            DescuentoL: 0,
            DescuentoD: 0,
            CreditoL: i?.CreditoL || 0,
            CreditoD: i?.CreditoD || 0,
            IdCuentaDescuento: null,
            IdAreaDescuento: null,
            IdUserEdit: userAuth.idUser,
            FechaEdit: getDateTimeStringSQL(new Date()),
            DisponibleL: i.BalanceDisponibleL,
            DisponibleD: i.BalanceDisponibleD,
            Porcentaje: i.PorcentajeDisponible,
            // IdTipoPago: 1,
            // BalanceL: i.BalanceL,
            // BalanceD: i.BalanceD,
            // MontoBalanceD: i.BalanceD,
            // MontoBalanceL: i.BalanceL,

            BalanceL: 0, //i.BalanceDisponibleL,
            BalanceD: 0, //i.BalanceDisponibleD,
            MontoBalanceD: 0, //i.BalanceDisponibleD,
            MontoBalanceL: 0, //i.BalanceDisponibleL,
            AjusteCambiarioD: 0,
            AjusteCambiarioL: 0,
            TasaCambioDocumento: i.TasaCambio,
            IsRegistroManual: i.IsRegistroManual,
            IdsRetencion: i?.IdsRetencion,
            changeRow: true,
            IncomeDate: "",
            InvoiceDate: i.FechaFactura,
            IncomeDate: i.FechaIngreso,
            Row: 1,
            IdCuentaDocumento: i.IdCuenta,
            CuentaDocumento: i?.CuentaContable,
          };
        });

        let nuevoArreglo = listadoDetalles.concat(dataNueva);
        setOpenOverlay(false);
        setListadoDetalles(nuevoArreglo);

        let porcentajeMax = Math.max(...nuevoArreglo.map((p) => p.Porcentaje));
        temValue.Porcentaje = porcentajeMax;
        AsignarMontos(temValue, nuevoArreglo);
      } else {
        toastShow(toast, "error", "No se Aceptan valores repetidos");
      }
    } else {
      toastShow(toast, "error", "Debe ingresar la tasa de cambio");
    }
  };

  const EliminarDetalle = () => {
    if (selected.length === 0)
      return toastShow(toast, "error", "Seleccione una fila para eliminar");
    confirmDialog({
      message: "¿Está seguro que desea eliminar los registros seleccionados?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        const nuevo = listadoDetalles.filter(
          (l) => !selected.some((s) => s.IdDetallePago === l.IdDetallePago),
        );
        setListadoDetalles(nuevo);
        setSelected([]);
      },
      reject: () => {},
    });
  };

  const table = {
    Data: listadoDetalles,
    // rowClassRules: rowClassRules,
    selected: selected,
    setSelected: setSelected,
    Columns: [
      {
        field: "CuentaDocumento",
        header: "Cuenta Documento",
        headerEn: "Cuenta Documento",
        className: "small",
        // width:100
        // hidden: userAuth.IdRol === 1
      },
      {
        field: "IdDetallePago",
        header: "IdDetalle",
        headerEn: "IdDetalle",
        className: "Xsmall",
        hidden: userAuth.IdRol === 1,
      },
      {
        field: "IdIngreso",
        header: "IdIngreso",
        headerEn: "IdIngreso",
        className: "Xsmall",
        hidden: userAuth.IdRol === 1,
        // onCellDoubleClicked: ({ data }) => {
        //   if (data.IdIngreso) {
        //     openDocumento(data)
        //   }
        // }
      },
      {
        field: "NumeroIngreso",
        header: "Numero Ingreso",
        headerEn: "Income Number",
        className: "medium",
        frozen: true,
        alignFrozen: "left",
        Sumary: "count",
        // onCellDoubleClicked: ({ data }) => {
        //   if (data.IdIngreso) {
        //     openDocumento(data, true)
        //   }
        // }
      },
      {
        field: "Factura",
        header: "Factura",
        headerEn: "Invoice",
        className: "medium",
        frozen: true,
        alignFrozen: "left",
        // onCellDoubleClicked: ({ data }) => {
        //   if (data.IdIngreso) {
        //     openDocumento(data)
        //   }
        // }
      },
      {
        field: "PO",
        header: "PO",
        headerEn: "PO",
        className: "small",
        onCellDoubleClicked: ({ data }) => {
          if (data.PO) {
            window.open(
              `${process.env.REACT_APP_ENV}/OrdenesCompra/${data.PO}`,
              data.PO,
              "height=800,width=1450",
            );
          }
        },
      },
      // {
      //   field: 'IncomeDate',
      //   header: 'Fecha Ingreso',
      //   headerEn: 'Income Date',
      //   className: '',
      //   Format: 'Date',
      // },
      {
        field: "InvoiceDate",
        header: "Fecha Factura",
        headerEn: "Invoice Date",
        className: "",
        Format: "Date",
      },
      {
        field: "MontoFacturaL",
        header: "Monto FacturaL",
        headerEn: "Amount Invoice L",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        Frozen: true,
        alignFrozen: "left",
        // hidden: ocultar
      },
      {
        field: "MontoFacturaD",
        header: "Monto Factura $",
        headerEn: "Amount Invoice $",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        Frozen: true,
        alignFrozen: "left",
        // hidden: !ocultar
      },

      {
        field: "MontoBalanceL",
        header: "Monto BalanceL",
        headerEn: "Monto BalanceL",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        // hidden: ocultar
      },
      {
        field: "MontoBalanceD",
        header: "Monto Balance $",
        headerEn: "Balance Amount $",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        // hidden: !ocultar
      },
      {
        field: "TasaCambioDocumento",
        header: "Tasa Cambio Factura",
        headerEn: "Tasa Cambio Factura",
        className: "small",
        Format: "Decimal",
        editable: true,
        onChange: (data) => {
          if (data?.newValue || data?.newValue === 0) {
            let det = data.data;
            det.TasaCambioDocumento = Number(data?.newValue);
            if (values.IdMoneda === 1) {
              det.MontoPagadoL = RedondearNumero(
                det.MontoPagadoD * det.TasaCambioDocumento,
              );
            } else {
              det.MontoPagadoD = RedondearNumero(
                det.MontoPagadoL / det.TasaCambioDocumento,
              );
            }

            det.BalanceD = RedondearNumero(
              det.MontoFacturaD -
                (det.MontoPagadoD + det.CreditoD + det.DescuentoD),
            );
            det.BalanceL = RedondearNumero(
              det.MontoFacturaL -
                (det.MontoPagadoL + det.CreditoL + det.DescuentoL),
            );
            det.MontoBalanceL = det.BalanceL;
            det.MontoBalanceD = det.BalanceD;
            det.changeRow = true;

            const tempo = [...listadoDetalles];
            const index = tempo.findIndex(
              (detail) => detail.IdDetallePago === det.IdDetallePago,
            );
            tempo[index] = det;

            setListadoDetalles(tempo);
          }
        },
        // Sumary: 'sum'
      },
      // {
      //   field: 'AjusteCambiarioL',
      //   header: 'AjusteCambiarioL',
      //   headerEn: 'AjusteCambiarioL',
      //   className: 'small',
      //   Format: 'Decimal',
      //   Sumary: 'sum',
      //   hidden: !ocultar
      // },

      // {
      //   field: 'AjusteCambiarioD',
      //   header: 'Ajuste CambiarioD',
      //   headerEn: 'Ajuste CambiarioD',
      //   className: 'small',
      //   Format: 'Decimal',
      //   Sumary: 'sum',
      //   hidden: ocultar || userAuth.IdRol === 1
      // },
      {
        field: "DescuentoL",
        header: "DescuentoL",
        headerEn: "DescuentoL",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        // hidden: ocultar || userAuth.IdRol === 1,
        editable: userAuth.IdRol === 1,
      },
      {
        field: "DescuentoD",
        header: "DescuentoD",
        headerEn: "DescuentoD",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        // hidden: !ocultar || userAuth.IdRol === 1,
        editable: userAuth.IdRol === 1,
      },
      {
        field: "CreditoL",
        header: "CreditoL",
        headerEn: "CreditoL",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        onChange: (data) => {
          if (data.newValue || data.newValue === 0) {
            let detalle = data.data;
            detalle.CreditoL = data.newValue;
            detalle.CreditoD = detalle.CreditoL / values.TasaCambio;
            let tempo = [...listadoDetalles];
            let index = tempo.findIndex(
              (t) => t.IdDetallePago === detalle.IdDetallePago,
            );
            tempo[index] = detalle;
            setListadoDetalles(tempo);
          }
        },
        // hidden: ocultar,
        editable: userAuth.IdRol === 1,
      },
      {
        field: "CreditoD",
        header: "CreditoD",
        headerEn: "CreditoD",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        // hidden: !ocultar,
        editable: userAuth.IdRol === 1,
      },
      //   {
      //     field: 'Porcentaje',
      //     header: 'Porcentaje',
      //     headerEn: 'Percentage',
      //     className: 'Xsmall',
      //     Format: 'Currency',
      //     Sumary: 'sum',
      //     suffix: '%',
      //     // editable: habilitar,
      //     frozen: true,
      //     alignFrozen: 'right',
      //     onChange: (data) => {
      //       if (data.newValue || data.newValue === 0) {
      //         let row = data.data
      //         let newMonto = 0
      //         let tempo = [...listadoDetalles]
      //         let rowsDetails = selected.length > 0 ? selected : [row]
      //         if (data.newValue >= 0 && data.newValue <= 100) {

      //           CambiarPorcentaje(data?.newValue, true, rowsDetails)
      //         } else {
      //           rowsDetails.map((r) => {
      //             r.changeRow = true
      //             r.Porcentaje = Number(data?.oldValue)
      //             let index = tempo.findIndex((t) => t.IdDetallePago === r.IdDetallePago)
      //             tempo[index] = r
      //           })
      //           setListadoDetalles(tempo)
      //           toastShow(toast, 'error', 'Debe ingresar un porcentaje valido 0-100 %')
      //         }

      //       }
      //     }
      //   },
      {
        field: "IdsRetencion",
        header: "IdsRetencion",
        headerEn: "IdsRetencion",
        className: "Xsmall",
        editable: userAuth.IdRol === 1,
        hidden: userAuth.IdRol === 1,
      },
      {
        field: "DisponibleL",
        header: "DisponibleL",
        headerEn: "DisponibleL",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        hidden: userAuth.IdRol === 1,
      },
      {
        field: "DisponibleD",
        header: "DisponibleD",
        headerEn: "DisponibleD",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        hidden: userAuth.IdRol === 1,
      },

      {
        field: "MontoPagadoL",
        header: "MontoPagadoL",
        headerEn: "MontoPagadoL",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        // hidden: ocultar || userAuth.IdRol === 1,
        // onChange: (data) => {
        //   if (data.newValue || data.newValue === 0) {
        //     CambiarMontoPagado(data, 2, values)
        //   }
        // },
        frozen: true,
        alignFrozen: "right",
      },
      {
        field: "MontoPagadoD",
        header: "MontoPagadoD",
        headerEn: "MontoPagadoD",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        // editable: ({ data }) => {
        //   if (data.IdTipoDocumento !== 5 && habilitar)
        //     return true
        //   // if(data)
        // },
        // hidden: !ocultar || userAuth.IdRol === 1,
        // onChange: (data) => {
        //   if (data.newValue || data.newValue === 0) {
        //     CambiarMontoPagado(data, 1, values)
        //   }
        // },
        frozen: true,
        alignFrozen: "right",
      },

      {
        field: "BalanceL",
        header: "BalanceL",
        headerEn: "BalanceL",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        // hidden: ocultar || userAuth.IdRol === 1,
        frozen: true,
        alignFrozen: "right",
      },
      {
        field: "BalanceD",
        header: "BalanceD",
        headerEn: "BalanceD",
        className: "small",
        Format: "Decimal",
        Sumary: "sum",
        // hidden: !ocultar || userAuth.IdRol === 1,
        frozen: true,
        alignFrozen: "right",
      },
    ],
  };

  useEffect(() => {
    if (dialogPago) {
      obtenerInformacion(IdPago);
      obtenerDropdowns();
    } else {
      setListadoDetalles([]);
      setSelected([]);
      resetForm({});
    }
  }, [dialogPago]);

  return (
    <Dialog
      visible={dialogPago}
      onHide={hideDialog}
      style={{ width: "80vw", height: "80vh" }}
      header={<h4>{values?.NumeroPago}</h4>}
      maximizable
      maximized
      closeOnEscape={false}
    >
      <Loader loading={loading} querySelector={"#ModalPagosProveedor"} />
      <Toast ref={toast} />

      <div id="ModalPagosProveedor">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "1rem",
          }}
          className="pt-2"
        >
          <span className="p-float-label">
            <Dropdown
              value={values.IdProveedor}
              onChange={(e) => {
                const proveedor = proveedores.find(
                  (p) => p.IdCustomer === e.value,
                );

                setValues({
                  ...values,
                  IdProveedor: e.value,
                  IdBancoBeneficiario: proveedor?.IdBanco ?? null,
                  BancoBeneficiario: proveedor?.Banco ?? "",
                  CuentaBancariaProveedor: proveedor?.NumeroCuentaBancaria ?? "",
                  IdCuentaPrincipal: proveedor?.IdCountry === 95 ? 15 : 16,
                });
              }}
              options={proveedores}
              optionValue="IdCustomer"
              optionLabel="CustomerName"
              filter
              filterBy="CustomerName"
              style={{ width: "100%" }}
            />
            <label>Proveedor</label>
          </span>

          <span className="p-float-label">
            <Calendar
              value={values.FechaPago}
              onChange={(e) => handleInputChange(e, "FechaPago")}
              style={{ width: "100%", height: 40 }}
              showIcon
              showButtonBar
              dateFormat="dd/mm/yy"
            />
            <label>Fecha Pago</label>
          </span>

          <span className="p-float-label">
            <Dropdown
              value={values.IdEstado}
              options={estados}
              optionValue="IdStatus"
              optionLabel="StatusName"
              disabled
              style={{ width: "100%" }}
            />
            <label>Estado</label>
          </span>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr 2fr",
            gap: "1rem",
          }}
          className="pt-3"
        >
          <span className="p-float-label">
            <Dropdown
              value={values.IdMoneda}
              onChange={(e) => handleInputChange(e, "IdMoneda")}
              options={monedas}
              optionValue="IdCurrency"
              optionLabel="Currency"
              style={{ width: "100%" }}
            />
            <label>Moneda</label>
          </span>

          <span className="p-float-label">
            <InputNumber
              value={values.TasaCambio}
              onChange={(e) => setValues({ ...values, TasaCambio: e.value })}
              minFractionDigits={2}
              maxFractionDigits={5}
              style={{ height: 40, width: "100%" }}
            />
            <label>Tasa de Cambio</label>
          </span>

          <span className="p-float-label">
            <NumericFormat
              value={values.MontoL}
              className="InputNumberStyle p-filled"
              disabled
              allowLeadingZeros
              thousandSeparator=","
              style={{ height: 40, width: "100%" }}
            />
            <label>Monto L</label>
          </span>

          <span className="p-float-label">
            <NumericFormat
              value={values.MontoD}
              className="InputNumberStyle p-filled"
              disabled
              allowLeadingZeros
              thousandSeparator=","
              style={{ height: 40, width: "100%" }}
            />
            <label>Monto $</label>
          </span>

          <span className="p-float-label">
            <InputText
              value={values.Memo}
              onChange={(e) => handleInputChange(e, "Memo")}
              style={{ width: "100%" }}
            />
            <label>Memo</label>
          </span>
        </div>

        <div className="pt-3">
          <Card
            titulo="Herramientas"
            contenido={
              <div className="d-flex gap" style={{ height: 40 }}>
                <Button
                  icon="pi pi-save"
                  tooltip="Guardar"
                  onClick={GuardarPago}
                  loading={loading}
                  disabled={values.IdPago > 0}
                />
                <Button
                  icon="pi pi-times"
                  tooltip="Eliminar seleccionados"
                  style={{ backgroundColor: "#f12456" }}
                  onClick={EliminarDetalle}
                />
                <Button
                  icon="pi pi-refresh"
                  tooltip="Refrescar"
                  onClick={() => obtenerDetallesPago(values.IdPago)}
                  disabled={values.IdPago <= 0}
                  loading={loading}
                />
                <Button
                  icon="pi pi-print"
                  tooltip="Imprimir"
                  disabled={values.IdPago <= 0}
                  onClick={() => setDialogReporte(true)}
                />
                <OverlayFacturasPendientesPorPagar
                  IdProveedor={values.IdProveedor}
                  NuevaFila={NuevaFila}
                  habilitar={habilitar}
                  valuesPago={values}
                  open={openOverlay}
                  detallesNuevos={detallesNuevos}
                />
              </div>
            }
          />
        </div>

        <div className="pt-2" style={{ height: "40vh" }}>
          <AgGrid table={table} />
        </div>
      </div>

      {/* <ReportePagoProveedor
            dialogReporte={dialogReporte}
            hideDialog={() => setDialogReporte(false)}
            IdPagoProveedor={values.IdPago}
        /> */}
    </Dialog>
  );
};

export default ModalPagosProveedores;
